import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect } from 'react';
import { Autocomplete, MenuDivider, MenuItem, useSnackbar } from '@emburse/embark-core';
import useCurrencies from '../../hooks/useCurrencies';
function CurrencySelect({ value, options, onSelect, style, className, label, helperText, disabled, multiple, multipleType, error, id, defaultValue, disableClearable, ...props }) {
    const { enqueueSnackbar } = useSnackbar();
    const { currencies, currenciesLoadingError, getCurrencyByCode, getCurrencyById } = useCurrencies();
    const snackbarHandler = useCallback((message, severity) => {
        enqueueSnackbar(message, { variant: 'alert', AlertProps: { severity } });
    }, [enqueueSnackbar]);
    const catchError = useCallback(() => {
        if (currenciesLoadingError) {
            snackbarHandler('Failed to load currencies', 'error');
        }
    }, [currenciesLoadingError, snackbarHandler]);
    useEffect(() => {
        if (currenciesLoadingError) {
            catchError();
        }
    }, [currenciesLoadingError, catchError]);
    const changeHandler = (e, currencyValue, reason) => {
        onSelect(currencyValue, reason);
    };
    const getLabelById = (val) => {
        const currency = getCurrencyById(val);
        return currency ? `${currency.Name} (${currency.Suffix})` : '';
    };
    const getLabelBySuffix = (val) => {
        const currency = getCurrencyByCode(val);
        return currency ? `${currency.Name} (${currency.Suffix})` : '';
    };
    const getOptionLabel = (option) => {
        if (typeof option === 'number') {
            return getLabelById(option);
        }
        if (typeof option === 'string') {
            return getLabelBySuffix(option);
        }
        const currencyOption = option;
        return `${currencyOption.Name} (${currencyOption.Suffix})`;
    };
    return (_jsx(Autocomplete, { style: style, className: className || '', label: label, helperText: helperText, error: error, id: id || 'CurrencySelect', disabled: disabled, value: value?.PK ? value : defaultValue, defaultValue: defaultValue, multiple: multiple, multipleType: multipleType, getOptionLabel: getOptionLabel, disableClearable: disableClearable, onChange: changeHandler, options: currencies, onBlur: (event) => {
            if (props.onBlurWithValue) {
                props.onBlurWithValue(event, value);
            }
            else if (props.onBlur) {
                props.onBlur(event);
            }
        }, renderOption: (_props, option) => {
            if (!option?.PK) {
                return _jsx(MenuDivider, {});
            }
            return _jsx(MenuItem, { ..._props, children: getOptionLabel(option) });
        }, ...props }, value?.PK));
}
CurrencySelect.defaultProps = {
    onSelect: () => { },
    onBlurWithValue: null
};
export default CurrencySelect;
